import './SeriesToggleLegend.scss';
import cn from 'classnames';
import { TrendSeries } from './trend-line-chart-types';

interface SeriesToggleLegendProps {
  series: TrendSeries[];
  visibleKeys: string[];
  onToggle: (key: string) => void;
}

// A legend whose entries turn series on and off: a filled square with a colored outline when the
// series is drawn, a hollow grey one when it is hidden.
export const SeriesToggleLegend = ({ series, visibleKeys, onToggle }: SeriesToggleLegendProps) => (
  <div className='series-toggle-legend'>
    {series.map(item => {
      const isOn = visibleKeys.includes(item.key);
      return (
        <button
          key={item.key}
          type='button'
          className={cn('series-toggle-legend-item', { 'is-off': !isOn })}
          aria-pressed={isOn}
          onClick={() => onToggle(item.key)}
          title={isOn ? `Hide ${item.label}` : `Show ${item.label}`}
        >
          <span
            className='series-toggle-legend-swatch'
            style={isOn ? { backgroundColor: item.color, borderColor: item.color } : undefined}
          />
          {item.label}
        </button>
      );
    })}
  </div>
);
